import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, mapRefSubtext, formatDate } from "helpers/row-logic-helper";

import {
  shouldShowFfectiveDate,
  forbearanceMapNestedRows,
  shouldShowPaymentDeferralStartDate,
  shouldShowPaymentDeferralEndDate,
  shouldShowDeferralRepaymentConditionId,
  shouldShowRepaymentTerm,
  shouldShowCovenants,
  shouldShowReporting,
  shouldShowDepositsAndReserves,
  shouldShowDistributionRestrictions,
  shouldShowCustomField,
  shouldShowTotalDeferredAmount
} from "./section-loan-forbearance-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  effectiveDate: {
    isVisible: data => shouldShowFfectiveDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Effective Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE_SUBTEXT,
        map: data => formatDate(defaultField(data, "forbearance.effectiveDate"), "MMM D, YYYY"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  paymentDeferralStartDate: {
    isVisible: data => shouldShowPaymentDeferralStartDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Payment Deferral Start Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE_SUBTEXT,
        map: data => formatDate(defaultField(data, "forbearance.paymentDeferralStartDate"), "MMM D, YYYY"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  paymentDeferralEndDate: {
    isVisible: data => shouldShowPaymentDeferralEndDate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Payment Deferral End Date",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DATE_SUBTEXT,
        map: data => formatDate(defaultField(data, "forbearance.paymentDeferralEndDate"), "MMM D, YYYY"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  deferralRepaymentConditionId: {
    isVisible: data => shouldShowDeferralRepaymentConditionId(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Deferral Repayment Condition",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "forbearance.deferralRepaymentCondition.value"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  repaymentTerm: {
    isVisible: data => shouldShowRepaymentTerm(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Repayment Term (Months)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL_SUBTEXT,
        map: covenants => defaultField(covenants, "forbearance.repaymentTerm"),
        Cell: tableSideColumnMapper,
        decimals: 0,
        subtextMappers: [
          { map: data => mapRefSubtext(data, "forbearance.appliesTo.value") }
        ]
      }
    ]
  },
  totalDeferred: {
    isVisible: data => shouldShowTotalDeferredAmount(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Total Deferred",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: data => defaultField(data, "forbearance.totalDeferred"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  covenants: {
    isVisible: data => shouldShowCovenants(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Covenants",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "forbearance.covenants"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  reporting: {
    isVisible: data => shouldShowReporting(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reporting",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "forbearance.reporting"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  depositsAndReserves: {
    isVisible: data => shouldShowDepositsAndReserves(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Deposits And Reserves",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "forbearance.depositsAndReserves"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  distributionRestrictions: {
    isVisible: data => shouldShowDistributionRestrictions(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Distribution Restrictions",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "forbearance.distributionRestrictions"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  /*
   * cashManagement: {
   *   cells: [
   *     {
   *       type: SIDE_TABLE_COLUMN_TYPES.COLUMN
   *       , width: DEFAULT_WIDTH
   *       , label: 'Cash Management'
   *       , Cell: tableSideColumnMapper
   *     }
   *     , {
   *       type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT
   *       , map: (data) => defaultField(data, 'forbearance.cashManagement')
   *       , Cell: tableSideColumnMapper
   *     }
   *   ],
   * },
   */
  customField: {
    isVisible: data => shouldShowCustomField(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Custom Fields",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT_NESTED,
        mapNestedRows: data => forbearanceMapNestedRows(data),
        map: row => defaultField(row, "name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [,
          { map: row => mapRefSubtext(row, "value") }]
      }
    ]
  }
};

